import { IComissoes } from './IComissoes'

export module Parceiros {
	export interface IDetalheParceiro {
		idParceiro: number
		documento: string
		parceiro: string
		idFranquia: number
		franquia: string
		idCanal: number
		canal: string
		idCategoria: number
		categoria: string
		email: string
		telefone: string
		ativo: boolean
		idUsuario: number
		consultor: string
		tipoPessoa: number
		cidade: string
		status: number
		situacao: number
		razaoSocial: string
		nomeFantasia: string
		nome: string
		message: string
		dtLiberacao: string
		dtCadastro: string
		dataNascimentoAbertura: string
		usuarioLiberacaoId: number
		logradouro: string
		cep: string
		bairro: string
		estado: string
		logradouroNumero: string
		complemento: string
		emailFinanceiro: string
		emailProcesso: string
		sexo: string
		banco: string
		agencia: string
		conta: string
		celular: string
		usuarioLiberacao: any
		apelido: string
		comissoes: Array<IComissoes>
		ctrAssinado: boolean
		usuarioResponsavelId: number
		usuarioResponsavelNome: string
	}

	export interface ICadastroParceirosOCR {
		email: string
		idCanal: number
		idResponsavel: number
		idFranquia: number
		tipoPessoa: number
		idCategoria: number
	}

	export interface IParametrosParceirosSearch {
		search: string
		itemsPerPage: number
		sortDesc: Array<boolean>
		page: number
		sortBy: Array<string>
		nextPage: boolean
	}

	export class CadastroParceirosOCR implements ICadastroParceirosOCR {
		email: string = ''
		idCanal: number = 0
		idResponsavel: number = 0
		idFranquia: number = 1 // valor fixo para testar API por enquanto
		tipoPessoa: number = 0
		idCategoria: number = 0
	}

	export interface IResponsavelParceiro {
		email: string
		franquiaId: number
		id: number
		nome: string
		pathAvatar: any
		status: boolean
		bloqueado: boolean
	}

	export interface ICategorias {
		categoria: string
		descricao: string
		id: number
	}

	export interface IAgentId {
		label: string
		id: number
	}

	export interface IParceiroTabela {
		agencia: string
		banco: string
		categoria: number
		celular: string
		cnpj: string
		conta: string
		ctrAssinado: number
		ddd: number
		dddCel: number
		ddi: number
		ddiCel: number
		dtCadastro: string
		dtLiberacao: string
		email: string
		emailFinanceiro: null
		emailProcesso: null
		enderecoBairro: string
		enderecoCep: string
		enderecoCidade: string
		enderecoComplemento: string
		enderecoEstado: string
		enderecoNumero: string
		enderecoRua: string
		id: number
		idFranquia: number
		idUsuCad: null
		idusuLib: number
		nome: string
		nomeFantasia: string
		nomeRef1: string
		nomeRef2: null
		razaosocial: string
		telefone: string
		tipoPessoa: null
		usuarioResponsavelId: number
	}
}
